var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "fill-height": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c("v-btn", { attrs: { small: "", to: "/freeSamples" } }, [
                _vm._v("Back to Free Samples")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.order
        ? _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("h4", [_vm._v("Customer Details")])
                              ]),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Order Code:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [_vm._v(_vm._s(_vm.order.orderCode))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Name:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.order.customerID.firstName
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.customerID.lastName
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Phone:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.order.customerID.phone)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Email:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "mailto:" +
                                                  _vm.order.customerID.email
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.order.customerID.email
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.order.customerID.address
                                    ? [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-list-tile-content", [
                                              _vm._v("Address:")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-content",
                                              { staticClass: "align-end" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.order.customerID.address
                                                      .address
                                                  )
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.order.customerID.address
                                                      .city
                                                  ) +
                                                    ", " +
                                                    _vm._s(
                                                      _vm.order.customerID
                                                        .address.state
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.order.customerID
                                                        .address.postcode
                                                    )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              {
                                                staticStyle: {
                                                  color: "red",
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [_vm._v("Address not found.")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                  _vm._v(" "),
                                  _vm.order.deliveryInstructions
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v("Order Instructions:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            { staticClass: "align-end" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.order.orderInstructions
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.order.deliveryInstructions
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v("Delivery Instructions:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            { staticClass: "align-end" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.order.deliveryInstructions
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _vm.order
                            ? _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("h4", [_vm._v("Actions")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            "Provide Australia Post Tracking Reference"
                                        },
                                        model: {
                                          value: _vm.order.trackingReference,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.order,
                                              "trackingReference",
                                              $$v
                                            )
                                          },
                                          expression: "order.trackingReference"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            "Email Customer Tracking Update",
                                          color: "primary"
                                        },
                                        model: {
                                          value: _vm.sendEmail,
                                          callback: function($$v) {
                                            _vm.sendEmail = $$v
                                          },
                                          expression: "sendEmail"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.markOrderAsSent()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Mark as Sent to Customer and Return"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _vm.order
                            ? _c(
                                "v-card",
                                [
                                  _c("v-card-title", [
                                    _c("h4", [_vm._v("Samples")])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    _vm._l(_vm.newFreeSamples, function(
                                      samples,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          samples.length > 0
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c("v-list-tile-content", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          index.replace(
                                                            /_/g,
                                                            " "
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(samples, function(
                                            sample,
                                            index2
                                          ) {
                                            return _c(
                                              "v-list-tile",
                                              { key: index2 },
                                              [
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    _vm._s(
                                                      sample.fabricID.name
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        sample.colourID.name
                                                      )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c(
                            "v-card",
                            [
                              _c("v-card-title", [
                                _c("h4", [_vm._v("Order History")])
                              ]),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _vm.showOrderHistory
                                ? _c(
                                    "table",
                                    {
                                      staticClass:
                                        "tableHistory text-xs-center pa-3",
                                      attrs: { width: "80%" }
                                    },
                                    [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v("Order Code")]
                                        ),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Date")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("No. of Samples")])
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.orderHistory, function(
                                        order,
                                        index
                                      ) {
                                        return _c("tr", { key: index }, [
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-left" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    flat: "",
                                                    color: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.$router.push({
                                                        path:
                                                          "/freeSampleOrder/" +
                                                          order.id
                                                      }),
                                                        (_vm.newFreeSamples = []),
                                                        _vm.getOrder()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(order.orderCode)
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(order.date))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(order.freeSamples))
                                          ])
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showOrderHistory === false
                                ? _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs8: "",
                                        "text-xs-center": "",
                                        m0a: ""
                                      }
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cdfbea6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdfbea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/freeSamples/FreeSampleOrder.vue
// module id = null
// module chunks = 